import {styled} from '@mui/material';

export const Container = styled('div')(() => ({}));

export const FieldContainer = styled('div')(() => ({
  marginTop: 20,
}));
